module.exports = __webpack_public_path__ + "assets/images/news-header@2x-a2c22d905af3d6ff79571d776abf49f4.jpg";